import {FeaturedIconPackGrid} from "../components/icons/FeaturedIconPackGrid";
import GlowBackground from "../components/animations/RevolutAnimation";
import {SearchHero} from "../components/common/SearchHero";
import {useCart} from "../context/CartContext";
import {FilterSearchSortBar} from "../components/common/FilterSearchSortBar";
import {IconGrid} from "../components/icons/IconGrid";
import {InfiniteLoader} from "../components/common/InfiniteLoader";
import React, {useState} from "react";

export const HomePage = (props: any) => {
    const [activeView, setActiveView] = useState("icons");
    const {isCartSideBarOpen} = useCart();
    
    return (
        <main className="w-full flex-grow flex flex-row overflow-x-hidden overflow-hidden">  

            <div
                className={`flex-grow min-w-0 transition-all duration-300 ease-in-out 
                ${isCartSideBarOpen ? 'lg:max-w-[calc(100%-320px)]' : ''}`}
            >
                <GlowBackground/>
                <SearchHero/>
                <FeaturedIconPackGrid/>
                
                <section className="max-w-6xl mx-auto px-4 sm:px-6 py-16">

                    <FilterSearchSortBar isActiveView={activeView} setActiveView={setActiveView}/>
                    {activeView === 'icons' ? <IconGrid/> : <FeaturedIconPackGrid/>}
                    <InfiniteLoader/>

                </section>

            </div>

        </main>
    );
};
